// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2WLr1","infoIcon":"styles_infoIcon__c817E"};